import { Moment } from 'moment';
import { DateType, DEFAULT_DATE_FORMAT } from 'api/models/core-types';

export const defaultFormat = (date: Moment): DateType =>
  date.format(DEFAULT_DATE_FORMAT);
